module.exports = __webpack_public_path__ + "static/media/text_3.9dcaae70.png";